import { useContext } from 'react';

import { Context, TContextDispatch } from '@r1-frontend/service-engineer-visit/context/Context';

const useContextDispatch = (): TContextDispatch => {
    const { dispatch } = useContext(Context);

    return dispatch;
};

export default useContextDispatch;
